<template lang="html">

  <section class="director-dashboard">
      <div class="pageHeading">
          <v-layout row wrap>
            <v-flex xs12 md6>
        <h1>Director Dashboard</h1>
            </v-flex>
            <v-flex xs12 md6>

                <v-autocomplete
                        v-model="$filterTripID"
                        :items="$structuredData.trips"
                        @change="selectedResult = null; participantGroupFilter = []"
                        color="black"
                        hide-no-data
                        hide-selected
                        item-text="prettyName"
                        item-value="_id"
                        label="Limit To Trip ID"
                        persistent-hint
                        solo
                        clearable
                        prepend-icon="mdi-database-search"
                        return-object
                ></v-autocomplete>
            </v-flex>
          </v-layout>
      </div>

      <v-container class="tripInfoContainer" grid-list-md text-xs-center v-if="$structuredData.selectedTrip != undefined">
          <v-layout row wrap>
              <v-flex md12 xs12>
                  <v-card elevation="5">
                      <v-container>
                          <v-layout row wrap>
                              <v-flex xs12 text-xs-center >

                                  <h3>{{$structuredData.selectedTrip.prettyName}}</h3>

                                  <div class="paymentDueDates">
                                  <span class="paymentDueDate paymentDueDate--deposit"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.depositPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Deposit</small></span><span>{{$structuredData.selectedTrip.depositPaymentDueDate | moment("MM-DD-YYYY")}}</span></span>
                                  <v-icon>forward</v-icon>
                                  <span class="paymentDueDate paymentDueDate--installment1"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.firstPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 1</small></span><span>{{$structuredData.selectedTrip.firstPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                  <v-icon>forward</v-icon>
                                  <span class="paymentDueDate paymentDueDate--installment2"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.secondPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 2</small></span><span>{{$structuredData.selectedTrip.secondPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                  <v-icon>forward</v-icon>
                                  <span class="paymentDueDate paymentDueDate--installment3"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.thirdPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 3</small></span><span>{{$structuredData.selectedTrip.thirdPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                  <v-icon>forward</v-icon>
                                  <span class="paymentDueDate paymentDueDate--installment4"><span class="paymentDueHeading"><v-icon v-if="isPastDueDate($structuredData.selectedTrip.finalPaymentDueDate)" class="paymentDueDate__pastIcon" title="Due date has passed">history</v-icon><small class="paymentDueLabel">Installment 4</small></span><span>{{$structuredData.selectedTrip.finalPaymentDueDate  | moment("MM-DD-YYYY")}}</span></span>
                                  </div>

                              </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                              <v-flex xs6>

                                  <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                      <h4>Quad Occupancy</h4>
                                  </v-flex>
                                  <v-flex xs12>
                                      <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.quadInstallments}} * 4 installments = ${{$structuredData.selectedTrip.quadPrice}}</p>
                                  </v-flex>


                              </v-flex>

                              <v-flex xs6>

                                  <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                      <h4>Triple Occupancy</h4>
                                  </v-flex>
                                  <v-flex xs12>
                                      <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.tripleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.triplePrice}}</p>
                                  </v-flex>


                              </v-flex>

                              <v-flex xs6>

                                  <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                      <h4>Double Occupancy</h4>
                                  </v-flex>
                                  <v-flex xs12>
                                      <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.doubleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.doublePrice}}</p>
                                  </v-flex>


                              </v-flex>

                              <v-flex xs6>

                                  <v-flex text-xs-left xs12 style="border-bottom: grey 1px solid">
                                      <h4>Single Occupancy</h4>
                                  </v-flex>
                                  <v-flex xs12>
                                      <p>${{$structuredData.selectedTrip.depositAmount}} deposit + ${{$structuredData.selectedTrip.singleInstallments}} * 4 installments = ${{$structuredData.selectedTrip.singlePrice}}</p>
                                  </v-flex>


                              </v-flex>
                          </v-layout>

                      </v-container>
                  </v-card>
              </v-flex>
          </v-layout>
      </v-container>


    <v-container class="tripInfoContainer" grid-list-md text-xs-center v-if="$structuredData.selectedTrip != undefined">
      <v-layout row wrap>

        <v-flex xs12>

          <v-card  elevation="5">
            <v-card-title primary-title>
              <v-flex>
                <h3 class="headline mb-0">Fundraising</h3>
                <div>Apply fundraising to one or more participants</div>
              </v-flex>
            </v-card-title>

            <v-card-actions>
              <v-layout row wrap>
                <v-flex

                    pa-1  style="border-top: lightgray 1px solid;">

                  <v-btn @click="$router.push('/FundRaising')" color="primary">Add New</v-btn>
                </v-flex>
              </v-layout>

            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs6>
          <v-card elevation="5">
            <v-container>
              <v-layout row wrap>

                <v-flex xs12 text-xs-center style="border-bottom: grey 1px solid" >

                  <h3 style="color:darkgreen">Trip Registration Information</h3>

                </v-flex>
              </v-layout>
              <v-layout row wrap>
               <v-flex xs12>
                 <br/>
                 <p><strong>Give this link to parents</strong> <br/><a :href="'https://ips.grouptravelplanners.com/#/TripInfo/' + $structuredData.selectedTrip._id">https://ips.grouptravelplanners.com/#/TripInfo/{{$structuredData.selectedTrip._id}}</a></p>
                <p>With this link parents can register their children and/or themselves for the trip.</p>
               </v-flex>
              </v-layout>


            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card elevation="5">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 text-xs-center style="border-bottom: grey 1px solid">
                  <h3 style="color:red">Director Login Information</h3>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <br/>
                  <p><strong>You can always login here</strong> <br/><a href="https://ips.grouptravelplanners.com">ips.grouptravelplanners.com</a></p>
                  <p>If your own children will be traveling, please create a new account with a personal email and add them as participants.</p>
                </v-flex>
              </v-layout>


            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

      <v-container grid-list-md text-xs-center >

          <div class="forceZIndex">

          <v-dialog  attach=".forceZIndex" @keydown.esc="dialog = false"
                  v-model="dialog"
                  fullscreen hide-overlay transition="scroll-x-transition"

          >
              <v-card v-if="selectedResult != null"
              >

                  <v-card-title primary-title style="background-color: #1976d2">

                      <v-flex xs1>

                      </v-flex>



                      <v-flex xs3 text-xs-right style="overflow: hidden;">
                          <v-btn @click="selectAParticipant(previousParticipant)" v-if="previousParticipant != null" class="mx-2"  dark small color="primary"
                          >

                              <v-icon dark>navigate_before</v-icon>
                              {{previousParticipant.firstName + ' '+ previousParticipant.middleName + ' ' + previousParticipant.lastName}}

                          </v-btn>
                      </v-flex>

                      <v-flex xs4 text-xs-center>
                          <h3 style="color: white"
                              class="headline mb-0">



                              {{selectedResult.firstName + ' '+ selectedResult.middleName + ' ' + selectedResult.lastName}}



                          </h3>
                          <p style="color: white; font-weight: bold">({{selectedResult.type}})</p>
                      </v-flex>


                      <v-flex xs3 text-xs-left  style="overflow: hidden;">
                          <v-btn @click="selectAParticipant(nextParticipant)" v-if="nextParticipant != null"  class="mx-2"  dark small color="primary"
                          >
                              {{nextParticipant.firstName + ' '+ nextParticipant.middleName + ' ' + nextParticipant.lastName}}

                              <v-icon dark>navigate_next</v-icon>
                          </v-btn>
                      </v-flex>


                      <v-flex xs1>
                          <v-btn class="mx-2" fab dark small color="primary"
                          @click="dialog = false"
                          >
                              <v-icon dark>close</v-icon>
                          </v-btn>
                      </v-flex>
                  </v-card-title>



                  <v-tabs v-model="tabs"
                          color="#c9ceea"
                          grow

                          slider-color="black"
                  >
                      <v-tab
                              key="1"
                              ripple
                      >
                          Summary

                      </v-tab>


                      <v-tab
                              key="2"
                              ripple
                      >
                          Make a Payment

                      </v-tab>

                      <v-tab-item
                              key="1"
                      >

                          <br/>
                          <v-container fluid>

                          <v-layout row wrap >


                              <v-flex xs12 style="border: 2px solid black">
                                  <v-layout row >
                          <v-subheader  style="    width: 100%; font-weight: bold;     background: #d8d8d8;" class="participantSummarySubHeader">Participant
                              <v-btn v-if="1==2" :disabled="resetPasswordWorking" @click="resetUserPassword(selectedResult.ParentUser)" color="secondary" small >{{resetPasswordWorking ? 'Resetting Password...' : 'Reset Password'}}</v-btn>
                              <v-btn v-if="1==2"  @click="$router.push('/Profile/'+ selectedResult.User._id)" color="secondary" small >Edit Profile</v-btn>
                          </v-subheader>
                                  </v-layout>

                          <v-layout row wrap class="summaryParticipantBoxes">
                              <v-flex >
                                  <span class="">{{selectedResult.gender}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Gender</strong>
                              </v-flex>
                              <v-flex >
                                  <span class="">{{selectedResult.DOB | moment("MM-DD-YYYY")}}</span>
                                  <br/>
                                  <strong class="bottomLabels">DOB</strong>

                              </v-flex>
                              <v-flex >
                                  <span class="">{{selectedResult.Occupancy}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Occupancy</strong>

                              </v-flex>
                              <v-flex>
                                  <span class="">{{selectedResult.email}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Email</strong>
                              </v-flex>
                              <v-flex>
                                  <span class="">{{selectedResult.phone}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Phone Number</strong>
                              </v-flex>




                          </v-layout>


                          <v-layout class="summaryParticipantBoxes">

                              <v-flex xs6 >
                                  <span class="">{{selectedResult.allergies}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Dietary Restrictions</strong>
                              </v-flex>

                              <v-flex xs6 >
                                  <span class="">{{selectedResult.GroupsPretty}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Group</strong>
                              </v-flex>

                          </v-layout>



                          <v-layout row wrap class="summaryParticipantBoxes">



                              <v-flex >
                                  <span class="">${{selectedResult.selectedTripCost}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Trip Cost</strong>
                              </v-flex>




                              <v-flex >
                                  <span class="">${{selectedResult.totalFundRaised}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Fundraising</strong>

                              </v-flex>
                              <v-flex>
                                  <span class="">${{selectedResult.totalPaid}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Payments</strong>
                              </v-flex>

                              <v-flex >
                                  <span class="">${{selectedResult.totalPending }}</span>
                                  <br/>
                                  <strong class="bottomLabels">Pending</strong>
                              </v-flex>


                              <v-flex >
                                  <span class="">${{selectedResult.totalRemaining}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Total Remaining</strong>
                              </v-flex>

                              <v-flex >
                                  <span class="">${{selectedResult.dueAmount }}</span>
                                  <br/>
                                  <strong class="bottomLabels">Next Due</strong>
                              </v-flex>

                              <v-flex >
                                  <span class="">{{selectedResult.nextDue | moment("MM/DD/YYYY")}}</span>
                                  <br/>
                                  <strong class="bottomLabels">Next Due Date</strong>
                              </v-flex>

                          </v-layout>

                          </v-flex>
                          </v-layout>



                          <br/>
                          <v-divider></v-divider>
                          <br/>


                          <v-layout row wrap v-if="selectedResult.Fees.length > 0">


                          <v-flex xs12 >


                              <v-subheader style="font-weight: bold;    background: #d8d8d8;" class="participantSummarySubHeader">Overdue Payment(s)</v-subheader>

                              <v-data-table class="overdueTable"  hide-actions :headers="[
              {
                text: 'Installment #',
                align: 'center',
                value: 'name',
                sortable:false
              },
              {
                  text: 'Overdue',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Unpaid',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Fee',
                  value: 'email',
                  sortable:false
              }
          ]" :items="selectedResult.Fees"
                              >
                                  <template slot="items" slot-scope="props">
                                      <tr style="color: red" v-bind:class="{ waivedFee: props.item.Waived }" >
                                          <td>{{props.item.Installment}}</td>
                                          <td class="text-xs-left">{{props.item.daysOverdue + ' day(s)'}}</td>
                                          <td class="text-xs-left">$200</td>
                                          <td class="text-xs-left">${{props.item.Amount}}</td>

                                      </tr>
                                  </template>

                              </v-data-table>
                              </v-flex>
                          </v-layout>


                          <v-layout row wrap >


                              <v-flex xs12  >

                          <v-subheader style="font-weight: bold;    background: #d8d8d8;" class="participantSummarySubHeader">Payment History</v-subheader>


                          <v-data-table class="paymentSummaryTable" hide-actions :headers="[

                {
                 text: 'Status',
                align: 'left',
                value: 'status'
              },
                {
                text: 'Type',
                align: 'center',
                value: 'type'
              },
              {
                text: 'Billing Name',
                align: 'center',
                value: 'name'
              },
              {
                  text: 'Last 4#',
                  align: 'center',
                  value: 'endingDigits'
              },
              {
                  text: 'Amount',

                  align: 'center',
                  value: 'amount'
              },
              {
                  text: 'Date',
                  value: 'date',

                  align: 'center'
              }
          ]" :items="selectedResult.Payments"
                          >
                              <template slot="items" slot-scope="props">
                                  <tr >
                                      <td class="text-xs-left">{{ props.item.Status  }}</td>
                                      <td class="text-xs-center">{{ props.item.Type  }}</td>
                                      <td class="text-xs-center">{{ props.item.BillingName }}</td>
                                      <td class="text-xs-center">{{props.item.Last4}}</td>
                                      <td class="text-xs-center">${{ props.item.Amount }}</td>
                                      <td class="text-xs-center">{{ props.item.Date | moment("MM-DD-YYYY") }}</td>


                                  </tr>
                              </template>

                          </v-data-table>
                              </v-flex>
                          </v-layout>

      </v-container>

                      </v-tab-item>

                      <v-tab-item
                              key="2"
                      >
                          <v-container fluid>


                          <v-layout row wrap>
                                  <v-flex xs12 md3>
                                  </v-flex>

                                  <v-flex xs12 md6>
                                      <payment-form v-bind:hidema="true" v-bind:hidefr ="true" v-bind:participant="[selectedResult]"
                                                    v-bind:maxPayment="selectedResult.maxPayment"  v-bind:initialPayment="selectedResult.dueAmount"  v-bind:minPayment="selectedResult.minPayment"
                                                    v-on:alertUser="(result, message) => {this.dialog = false; this.$emit('alertUser', result, message);}"></payment-form>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-tab-item>
                  </v-tabs>

              </v-card>

          </v-dialog>
          </div>

        <v-layout row wrap>
          <v-flex md12 xs12>

                  <v-card elevation="5">

                      <div>

                      <v-card-title primary-title>

                          <v-flex xs2 text-xs-center>

                          </v-flex>

                          <v-flex xs8 text-xs-center>
                              <h3 class="headline mb-0">Travelers Status</h3>
                              <div>List of the newest registrations for this trip</div>
                          </v-flex>

                          <v-flex xs2 text-xs-center>
                              <v-btn @click="exportToExcel"  color="secondary"
                              ><v-icon style="margin-right: 10px" dark>cloud_download</v-icon> Export Report
                              </v-btn>
                          </v-flex>



                      </v-card-title>


                      <v-container  style="border-top: lightgray 1px solid; padding: 5px; padding-bottom: 0px; "  >

                          <v-layout v-ripple row wrap class="tripStatBoxes">
                              <v-flex xs2 @click="applyFilter('all')" v-bind:class="{ selectedFilter: filter == 'all' }" >
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Registrations</strong>

                              </v-flex>
                              <v-flex xs2 @click="applyFilter('fr')" v-bind:class="{ selectedFilter: filter == 'fr' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.totalFundRaised > 0).length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Fundraisers</strong>
                              </v-flex>
                              <v-flex xs2 @click="applyFilter('mp')" v-bind:class="{ selectedFilter: filter == 'mp' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.totalPaid > 0).length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Made Payment</strong>
                              </v-flex>
                              <v-flex xs2 @click="applyFilter('fp')" v-bind:class="{ selectedFilter: filter == 'fp' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => (participant.totalPaid + participant.totalFundRaised) == participant.selectedTripCost).length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Fully Paid</strong>
                              </v-flex>
                              <v-flex xs2 @click="applyFilter('pd')" v-bind:class="{ selectedFilter: filter == 'pd' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.dueAmount > 0 && participant.daysToDue < 3  && participant.daysToDue >= 0).length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Payment Due</strong>
                              </v-flex>
                              <v-flex xs2 @click="applyFilter('po')" v-bind:class="{ selectedFilter: filter == 'po' }">
                                  <span class="topTextBottomLabels">
                                      {{filteredByGroupParticipants.filter((participant) => participant.dueAmount > 0 && participant.daysToDue < 0).length}}
                                  </span>
                                  <br/>
                                  <strong class="bottomLabels">Payment Overdue</strong>
                              </v-flex>
                          </v-layout>

                      </v-container>



                      <v-card-actions v-if="$filterTripID != null && $filterTripID.customOptions != undefined && $filterTripID.customOptions.length > 0">
                          <v-layout  row wrap justify-content-center align-items-center style="border-top: lightgray 1px solid;">

                              <v-flex >
                                  <v-divider  class="ma-1"></v-divider>
                                  <h4>Filter By Group:</h4>
                                  <v-divider class="ma-1"></v-divider>
                              </v-flex>
                              <v-flex fluid v-for="option in $filterTripID.customOptions">
                              <v-checkbox  class="ma-1" v-model="participantGroupFilter"l
                                          hide-details :value="option.ID" :label="option.label" ></v-checkbox>
                              </v-flex>
                          </v-layout>

                      </v-card-actions>

                      </div>

                      <div v-show="this.filter != ''" style="border-top: 2px solid black;     margin-top: 2px;">




                          <v-data-table hide-actions :headers="[
              {
                text: 'Name / Email',
                align: 'left',
                value: 'firstName'
              },
              {
                  text: 'Phone / Gender',
                  value: 'gender'
              },
              {
                  text: 'Fundraising / Total Paid',
                  value: 'totalFundRaised'
              },

              ,
              {
                  text: 'Total Late Fees',
                  value: 'totalFee'
              },

               {
                  text: 'Trip Cost / Remaining',
                  value: 'totalRemaining'
              },
              {
                  text: 'Next Payment / Due Date',
                  value: 'selectedTripCost'
              }
          ]" :items="filteredParticipants"
                          >
                              <template slot="items" slot-scope="props">
                                  <tr style="cursor: pointer"  @click.stop="selectAParticipant(props.item)">
                                      <td>{{ props.item.firstName + ' ' + props.item.lastName  }}
                                          <br/>
                                          {{ props.item.email }}</td>
                                      <td>{{ props.item.gender}}
                                          <br/>
                                          {{ props.item.phone }}</td>

                                      <td>${{ props.item.totalFundRaised}}<br/>${{ props.item.totalPaid }}</td>

                                        <td>${{ props.item.totalFee}}</td>


                                      <td>${{ props.item.selectedTripCost}}
                                          <br/>
                                          ${{ props.item.totalRemaining}}</td>

                                      <td>${{ props.item.dueAmount}}
                                          <br/>
                                          {{ props.item.nextDue | moment("MM-DD-YYYY")}}</td>
                                  </tr>

                              </template>

                          </v-data-table>

                      </div>
                  </v-card>

          </v-flex>

        </v-layout>
      </v-container>

          <v-container grid-list-md text-xs-center>
        <v-layout row wrap>

          <v-flex xs12 md6>

            <trip-messages v-bind:showCreate="true" v-bind:selectedTrip="$filterTripID">

            </trip-messages>
          </v-flex>

            <v-flex md6 xs12>

                <v-card elevation="5">

                    <v-card-title primary-title>
                        <v-flex xs12 text-xs-center>
                            <h3 class="headline mb-0">Overdue Participants</h3>
                            <div>List of the payment progress for participants of all (or selected) trips</div>
                        </v-flex>



                    </v-card-title>


                    <v-container style="border-top: lightgray 1px solid;">

                        <v-timeline
                                dense
                        >


                            <v-timeline-item v-for="participant in $structuredData.participants" v-if="participant.daysToDue < 0 && !participant.disabled"

                                             :color="participant.color"
                                             small
                                             icon="date_range"
                            >
                                <v-layout pt-3 style="cursor: pointer"
                                          @click="expanded = participant">
                                    <v-flex xs6>
                                        <strong>{{participant.firstName + ' ' + participant.lastName}}</strong>
                                        <br/>
                                        <strong v-bind:style="{ color: participant.color }">Payment Due {{participant.nextDue | moment("MMM Do")}}</strong>

                                        <div class="caption"></div>
                                    </v-flex>
                                    <v-flex>
                                        <div class="caption">

                                            <v-progress-linear class="paymentMeterBar"  v-model="participant.percentPaid"></v-progress-linear>
                                            <span><strong>${{participant.totalFundRaised + participant.totalPaid}}</strong> of ${{participant.selectedTripCost}}</span>
                                        </div>
                                    </v-flex>

                                </v-layout>


                                <v-layout row wrap v-show="participant == expanded">
                                    <v-flex

                                            pa-1  style="border-bottom: lightgray 1px solid;">

                                        <v-btn color="primary" dark small>Add Payment</v-btn>
                                        <v-btn color="#af0b0b" small dark>Add Fee</v-btn>
                                    </v-flex>
                                </v-layout>

                            </v-timeline-item>
                        </v-timeline>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
      </v-container>
  </section>

</template>

<script lang="js">
    import tripMessages from '../components/TripMessages'
    import paymentForm from '../components/PaymentForm'
    import XLSX from 'xlsx'
    import moment from'moment';
  export default  {
    name: 'director-dashboard',
    props: [],
      components: {
          tripMessages,
          paymentForm
      },
    mounted() {
    },
    data() {
      return {
          participantGroupFilter: [],
          expanded: null,
          selectedResult: null,
          dialog: false,
          filter: 'all',
          resetPasswordWorking: false
      }
    },
    methods: {
        isPastDueDate(date) {
            if (!date) return false

            const dueDate = new Date(String(date).slice(0, 10) + 'T00:00:00')
            if (isNaN(dueDate.getTime())) return false

            const today = new Date()
            today.setHours(0, 0, 0, 0)
            return dueDate < today
        },
        resetUserPassword(user) {
            var vueThis = this
            this.resetPasswordWorking = true
            this.$services.authmanagement.create({
                "action": "sendResetPwd",
                "value": { "email": user.email}

            }).then(()=>{
                alert("Sent password reset email")
                this.resetPasswordWorking = false
            }).catch((err)=>{
                alert("Failed to reset password")
                this.resetPasswordWorking = false
            })
        },
        exportToExcel() {
            var wb = XLSX.utils.book_new();


//Vue.prototype.$userData = {"new": true}

            var ws_name = "SheetJS";

            /* make worksheet */
            var ws_data = [
                [ "First Name", "Middle Name", "Last Name", "Email", "Phone Number", "Gender", "Type", "DOB", "Occupancy", "Group", "Dietary Restrictions",
                    "Trip Cost", "Fundraising Total", "CC / Check Total", "Total Late Fees", "Next Due Amount", "Next Due Date", "Total Remaining" ]
            ];

            this.filteredParticipants.forEach((participant) => {
                let row = []
                row.push(participant.firstName)
                row.push(participant.middleName)
                row.push(participant.lastName )
                row.push(participant.email)
                row.push(participant.phone)
                row.push(participant.gender)
                row.push(participant.type)
                row.push(participant.DOB)
                row.push(participant.Occupancy)
                row.push(participant.GroupsPretty)
                row.push(participant.allergies)
                row.push(participant.selectedTripCost)
                row.push(participant.totalFundRaised)
                row.push(participant.totalPaid)
                row.push(participant.totalFee)
                row.push(participant.dueAmount)
                row.push(moment(participant.nextDue).format('MM-DD-YYYY'))
                row.push(participant.totalRemaining)
                ws_data.push(row)
            })


            var ws = XLSX.utils.aoa_to_sheet(ws_data);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, ws_name);



            XLSX.writeFile(wb, 'Participants_Export.xlsx');

        },
        selectAParticipant(participant) {
            this.dialog = true
            this.selectedResult = participant
        },
        applyFilter(filter) {
            if(this.filter != filter) {
                this.filter = filter
            } else {
                this.filter = 'all'
            }
            console.log('filter11111111111', filter)

        }
    },
    computed: {
        nextParticipant() {
            let index = this.filteredParticipants.indexOf(this.selectedResult);
            if (index + 1 >= this.filteredParticipants.length) {
                return null
            } else {
                return this.filteredParticipants[index + 1]
            }
        },
        previousParticipant() {
            let index = this.filteredParticipants.indexOf(this.selectedResult);
            if (index - 1 < 0) {
                return null
            } else {
                return this.filteredParticipants[index - 1]
            }
        },
        filteredByGroupParticipants() {
            var toReturn = []

            this.$structuredData.participants.forEach((participant)=>{
                if(!participant.disabled) {
                    if (this.participantGroupFilter.length > 0) {
                        participant.Group.forEach((group) => {
                            if (this.participantGroupFilter.includes(group) && !toReturn.includes(participant)) {
                                toReturn.push(participant)
                            }
                        })
                    } else if (!toReturn.includes(participant)) {
                        toReturn.push(participant)
                    }
                }
            })

            console.log('dfasdfsadf', toReturn)
            return toReturn

        },
        filteredParticipants() {
            var toReturn = []

            console.log('about to filter!', this.$structuredData.participants)
            this.$structuredData.participants.forEach((participant)=>{
                if(!participant.disabled) {
                    var clearedGroup = true;

                    if (this.participantGroupFilter.length > 0) {
                        participant.Group.forEach((group) => {
                            clearedGroup = this.participantGroupFilter.includes(group)
                        })
                    }


                    if (clearedGroup) {
                        if (this.filter == 'all') {
                            toReturn.push(participant)
                        } else if (this.filter == 'fr' && participant.totalFundRaised > 0) {
                            toReturn.push(participant)
                        } else if (this.filter == 'mp' && participant.totalPaid > 0) {
                            toReturn.push(participant)
                        } else if (this.filter == 'fp' && (participant.totalPaid + participant.totalFundRaised) == participant.selectedTripCost) {
                            toReturn.push(participant)
                        } else if (this.filter == 'pd' && participant.dueAmount > 0 && participant.daysToDue < 3 && participant.daysToDue >= 0) {
                            toReturn.push(participant)
                        } else if (this.filter == 'po' && participant.daysToDue < 0 && participant.dueAmount > 0) {
                            toReturn.push(participant)
                        }
                    }
                }
            })

            return toReturn

        }

    }
}
</script>
<style>
    .forceZIndex .v-dialog__content--active {
        z-index: 1900 !important;
    }
</style>
<style scoped lang="scss">


    .selectedFilter {
        background-color: #1976d2;
        color: white;
    }
  .director-dashboard { }


    .summaryParticipantBoxes > div.flex {
        border: 1px solid gray;
    }

    .selectedSearchResult {
        background-color: #c9ceea;
        border-bottom: 2px black solid;
        border-top: 2px black solid;
    }


  .BottomLabels {
      text-decoration: overline;
      font-size: 12px;
      position: relative;
      top: -3px;
  }

  .topTextBottomLabels {
      font-size: 35px;
  }


  .tripStatBoxes>div:hover{
      cursor: pointer;
      background-color: #1976d2e6;
      color: white;
  }

  .paymentDueDates {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
      gap: 6px 20px;
  }

  .paymentDueDate {
      display: inline-flex;
      flex-direction: column;
      min-width: 110px;
      text-align: center;
  }

  .paymentDueDate small {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: .04em;
      text-transform: uppercase;
  }

  .paymentDueHeading {
      align-items: center;
      display: flex;
      gap: 2px;
      justify-content: center;
  }

  .paymentDueDate__pastIcon {
      color: #727273;
      font-size: 13px;
  }

  .paymentDueDate--deposit .paymentDueLabel { color: #6f747a !important; }
  .paymentDueDate--installment1 .paymentDueLabel { color: #626970 !important; }
  .paymentDueDate--installment2 .paymentDueLabel { color: #555c63 !important; }
  .paymentDueDate--installment3 .paymentDueLabel { color: #484f56 !important; }
  .paymentDueDate--installment4 .paymentDueLabel { color: #3b4249 !important; }
</style>
